import Typography from '@components/v2/ui/Typography/Typography';
import { ToggleButton, ToggleButtonProps } from '@mui/material';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../translation/TranslationContext';
import { useProductFiltersStyles } from '../../../ProductFilters/styles/useProductFilters.styles';

interface ProductFilterToggleButtonProps extends ToggleButtonProps {
  label: LangEnum;
  testId?: string;
}

export const ProductFilterToggleButton = ({
  value,
  onClick,
  selected,
  label,
  testId,
  ...otherProps
}: ProductFilterToggleButtonProps) => {
  const { translate } = useTranslation();
  const { classes, cx } = useProductFiltersStyles();

  const defaultClassName = cx(
    classes.filterButton,
    selected && classes.selectedFilterButton,
    selected && otherProps.disabled && classes.disabledSelectedFilterButton,
  );

  return (
    <ToggleButton
      {...otherProps}
      value={value}
      tabIndex={-1}
      onClick={onClick}
      selected={selected}
      aria-label={translate(label)}
      className={otherProps.className ?? defaultClassName}
      {...(testId ? { 'test-id': testId } : {})}
    >
      <Typography variant="body2" color="inherit" sx={{ lineHeight: 1 }}>
        {translate(label)}
      </Typography>
    </ToggleButton>
  );
};

export default ProductFilterToggleButton;
